import { type ReactNode } from "react";

import type { PermissionValue } from "entities/permissions";

import { SelectPermission } from "./select";

type Props = {
  icon: ReactNode;
  title: ReactNode;
  value: PermissionValue;
  onValueChanged: (newValue: PermissionValue) => void;
};

export const SetPermissionRow = (props: Props) => {
  const { icon, title, value, onValueChanged } = props;

  const image =
    typeof icon === "string" ? <img className="size-full" src={icon} /> : icon;

  return (
    <div className="bg-oil flex flex-wrap items-center gap-x-8 gap-y-2 rounded-xl p-3">
      <div className="mr-auto flex items-center gap-4">
        <div className="size-9.5 shrink-0">{image}</div>
        <div className="text-lg leading-5.5 tracking-[0.4px]">{title}</div>
      </div>
      <SelectPermission value={value} onValueChanged={onValueChanged} />
    </div>
  );
};
